import SalesOrderItemsList from './SalesOrderItemsList'

export default {
  list: SalesOrderItemsList,
}
